



























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Form, Calendar, List, PullRefresh, Empty } from "vant";
import { TaskFormEntity } from "../../../model/Btrip";
import btripServcice from "@/service/btripServcice";
import { removeKeepalive } from "@/views/modules/keepUtils";

@Component({
  name: "cardList",
  components: {
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
  },
})
export default class extends Vue {
  @Prop()
  toChildPageStatus?: string;
  delID = "1";
  isLoading = false;
  isPullUploading = false;
  finished = false;
  isLaunch = false;
  searchValue = "";
  queryMOdel = {
    PageNo: 0,
    PageSize: 20,
    CreateByName: "",
    TaskName: "",
    TaskStatus: "",
    TaskID: "",
  };
  query = {
    PageNo: 1,
    PageSize: 20,
    CreateByName: "",
    TaskName: "",
    TaskStatus: "",
    TaskID: "",
  };
  searchModel = {
    TaskID: "",
  };
  tags = {
    CreateByName: "",
    TaskName: "",
    TaskID: "",
  };
  tagsNumber = {
    pendingtags: "",
    launchtags: "",
    processedtags: "",
  };
  pageStatus = "";
  TaskForm: TaskFormEntity[][] = [];
  LaunchTaskForm: TaskFormEntity[][] = [];
  ProcessedTaskForm: TaskFormEntity[][] = [];
  created() {
    this.query.CreateByName = String(this.profile.UserName);
  }
  mounted() {
    console.log("加载了mounted");
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  onLoad() {
    this.queryMOdel.PageNo++;
    switch (this.toChildPageStatus) {
      case "待我处理":
        this.queryMOdel.CreateByName = String(this.profile.UserName);
        btripServcice.getTasklist(this.queryMOdel as any).then((json: any) => {
          if (json.isSucc) {
            if (json.result.entities.length === 0) {
              this.finished = true;
            } else {
              for (let i = 0; i < json.result.entities.length; i++) {
                if (json.result.entities[i].TaskStatus !== "审批拒绝" && json.result.entities[i].TaskStatus !== "审批通过") {
                  this.TaskForm.push(json.result.entities[i]);
                }
              }
              this.isPullUploading = false;
            }
          }
        });
        break;
      case "我发起的":
        this.queryMOdel.TaskName = String(this.profile.UserName);
        btripServcice.getTasklist(this.queryMOdel as any).then((json: any) => {
          if (json.isSucc) {
            for (let i = 0; i < json.result.entities.length; i++) {
              this.TaskForm.push(json.result.entities[i]);
            }
            if (json.result.entities.length === 0) {
              this.finished = true;
            }
            this.isPullUploading = false;
          } else {
            this.$notify({ type: "warning", message: "请检查网络设置" });
          }
        });
        break;
      case "我已处理":
        btripServcice.getTasklist(this.queryMOdel as any).then((json: any) => {
          if (json.isSucc) {
            for (let i = 0; i < json.result.entities.length; i++) {
              if (json.result.entities[i].TaskStatus == "审批拒绝" || json.result.entities[i].TaskStatus == "审批通过") {
                this.TaskForm.push(json.result.entities[i]);
              }
            }
            if (json.result.entities.length === 0) {
              this.finished = true;
            }
            this.isPullUploading = false;
          } else {
            this.$notify({ type: "warning", message: "请检查网络设置" });
          }
        });
        break;
    }
  }
  onRefresh() {
    switch (this.toChildPageStatus) {
      case "待我处理":
        this.ModelReset();
        this.query.CreateByName = String(this.profile.UserName);
        this.TaskForm = [];
        btripServcice.getTasklist(this.query).then((json: any) => {
          if (json.isSucc) {
            for (let i = 0; i < json.result.entities.length; i++) {
              if (json.result.entities[i].TaskStatus !== "审批拒绝" && json.result.entities[i].TaskStatus !== "审批通过") {
                this.TaskForm.push(json.result.entities[i]);
              }
            }
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.$notify({ type: "warning", message: "请检查网络设置" });
          }
        });
        break;
      case "我发起的":
        this.ModelReset();
        this.query.TaskName = String(this.profile.UserName);
        btripServcice.getTasklist(this.query).then((json: any) => {
          if (json.isSucc) {
            this.TaskForm = [];
            for (let i = 0; i < json.result.entities.length; i++) {
              this.TaskForm.push(json.result.entities[i]);
            }
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.$notify({ type: "warning", message: "请检查网络设置" });
          }
        });
        break;
      case "我已处理":
        this.ModelReset();
        this.query.CreateByName = String(this.profile.UserName);
        btripServcice.getTasklist(this.query).then((json: any) => {
          if (json.isSucc) {
            this.TaskForm = [];
            for (let i = 0; i < json.result.entities.length; i++) {
              if (json.result.entities[i].TaskStatus === "审批拒绝" || json.result.entities[i].TaskStatus === "审批通过") {
                this.TaskForm.push(json.result.entities[i]);
              }
            }
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.$notify({ type: "warning", message: "请检查网络设置" });
          }
        });
        break;
    }
  }
  ModelReset() {
    (this.query.PageNo = 1), (this.query.PageSize = 20), (this.query.CreateByName = ""), (this.query.TaskName = ""), (this.query.TaskStatus = "");
    this.query.TaskID = "";
    (this.queryMOdel.PageNo = 0), (this.queryMOdel.PageSize = 20), (this.queryMOdel.CreateByName = ""), (this.queryMOdel.TaskName = ""), (this.queryMOdel.TaskStatus = "");
    this.queryMOdel.TaskID = "";
  }
  automaticSearch() {
    if (/^S\d{11}$/.test(this.searchValue)) {
      this.searchModel.TaskID = this.searchValue;
      btripServcice.getTasklist(this.searchModel).then((json: any) => {
        if (json.isSucc) {
          this.TaskForm = json.result.entities;
        }
      });
    } else {
      this.onRefresh();
      this.$notify({ type: "warning", message: "请输入正确的单号" });
    }
  }
  CardDetails(cardItem: any) {
    removeKeepalive(this.$route.path);
    this.$router.push({
      name: "cardDetails",
      params: {
        item: cardItem,
      },
    });
  }
}
